import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Content,
  Header,
  Loader,
  SelectPicker,
  CheckPicker,
  Checkbox,
  Radio,
} from "rsuite";
import { Form, Field } from "react-final-form";
import { StoreServices } from "../../../core/services/StoreServices";
import { HelperServices } from "../../../core/services/HelperServices";
import "./Store.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get, debounce, uniq, findIndex, findKey } from "lodash/fp";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import CustomSelector from "../../shared/customSelector";
import { useTranslation } from "react-i18next";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { StoreFields } from "./StoreDataTypes";
import {
  httpStatusArr,
  messageTypeArr,
  appConstObj,
  roleObjArr,
  roleTypeArr,
} from "../../../core/config/AppConstants";
import { ValidatorCustom } from "./../../validators/ValidatorCustom";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { isNotNull } from "../../../utils/helpers";
import UserForCompany from "../Users/UserForCompany";
import UserForStore from "../Users/UserForStore";
function Store() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loader, setLoading] = useState(true);
  const countryList = useSelector((state: any) => state.country.data);
  const company = useSelector((state: any) => state.company);
  const params: any = useParams();
  const [storeData, setStoreData] = useState<StoreFields>({});
  const [stateList, setStateList] = useState([]);
  const [stateFetched, setSateFetched] = useState(false);
  const [cityList, setCityList] = useState([]);
  const [cityFetched, setCityFetched] = useState(false);
  const [areas, setAreas] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [storeGroupList, setStoreGroupList] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedAreaId, setSelectedAreaId] = useState("");
  const [openModalByName, setOpenModalByName] = useState("");
  const areaRef = useRef<any>();
  const buildingRef = useRef<any>();
  let [decryptedParams] = useDecryptedParams(params);

  const ecryptedStoreId = encryptUrl(`${decryptedParams.id}`);

  const [formData, setFormData] = useState<any>({
    store_name: "",
    store_code: "",
    comp_id: null,
    mobile: "",
    region_id: "",
    store_group_id: "",
    contact_person1_name: "",
    contact_person1_phone: "",
    contact_person1_email: "",
    contact_person2_name: "",
    contact_person2_email: "",
    contact_person2_phone: "",
    house_no: "",
    building: "",
    area_name: "",
    landmark: "",
    pincode: "",
    landline: "",
    country_id: null,
    state_id: null,
    city_id: null,
    status: 1,
  });

  async function init() {
    try {
      if (decryptedParams.id) {
        const response: any = await StoreServices.viewStore(
          +decryptedParams.id
        );
        const storeData: any = response?.data?.data;
        const keyMapper: any = { building: "building_name" };
        setStoreData(storeData);
        let obj = { ...formData };
        //review comment: response?.data?.data? should be in a single variable and then used further upon;
        let keyMapperIndex = Object.keys(keyMapper);
        Object.keys(obj).map((formKey) => {
          if (keyMapperIndex.includes(formKey)) {
            obj[formKey] = storeData[keyMapper[formKey]];
          } else {
            obj[formKey] = storeData[formKey];
          }
        });
        setFormData({ ...obj });
        if (obj.region_id) {
          handleRegionChange(obj.region_id);
        }
        if (obj.country_id) {
          handleCountryChange(obj.country_id);
        }
        if (obj.state_id) {
          handleStateChange(obj.state_id);
        }
        if (obj.city_id && obj.state_id && obj.country_id) {
          searchArea("", obj.city_id);
          searchBuilding("", obj.city_id);
        }
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    init();
  }, [decryptedParams.id]);

  useEffect(() => {
    getRegionList();
  }, [company.id]);

  async function getRegionList(forComp?: number) {
    let compId: number = forComp ? forComp : getCompanyId();
    setRegionList([]);
    setStoreGroupList([]);
    if (!compId) {
      return;
    }
    let params: any = {};
    if (compId) {
      params.company = compId;
    }

    try {
      const res = await StoreServices.getRegions(params);
      const respData = get("data.data", res);
      if (respData.length) {
        setRegionList(respData);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }
  async function handleRegionChange(regionId: number) {
    try {
      setStoreGroupList([]);
      if (!regionId) {
        return;
      }
      const res = await StoreServices.getStoreGroups({
        region: regionId,
      });
      const respData = get("data.data", res);
      setStoreGroupList(respData);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  // function clearRegion() {
  //   handleFormChanges({ path: "region", value: "" });
  //   setStoreGroupList([]);
  // }

  function getCompanyId() {
    let compId = null;
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (company?.id) {
      compId = company.id;
    }
    return compId;
  }

  function onCompletePrimaryUser() {
    init();
  }

  async function handleStateChange(stateId: any) {
    try {
      const res = await HelperServices.getAllValidCities({ state: stateId });
      const respData = get("data.data", res);
      // add optional chaining checks in case of failure (res?.data?.data), Although i would recommend using get operator from lodash.
      setCityList(respData);
      setCityFetched(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleCountryChange(countryId: any) {
    try {
      const stateRes = await HelperServices.getAllValidStates({
        country: countryId,
      });
      const respData = get("data.data", stateRes);
      setStateList(respData);
      // add optional chaining checks in case of failure (res?.data?.data), Although i would recommend using get operator from lodash.
      setSateFetched(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function saveStore(form: any, storeId?: any) {
    try {
      setLoading(true);
      let response: any;
      if (storeId) {
        response = await StoreServices.updateStore(+storeId, form);
      } else {
        response = await StoreServices.createStore(form);
      }
      setStoreData(response?.data?.data);
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      navigate(ContentRoutes.STORES);
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    }
  }

  const dbounceArea = useCallback(
    debounce(1000, (searchAreaValue: string, cityId: any) => {
      searchArea(searchAreaValue, +cityId);
    }),
    []
  );

  const handleAreaSearch = (value: any, cityId: any) => {
    dbounceArea(value, cityId);
  };

  async function searchArea(search: string, cityId: number) {
    try {
      if (decryptedParams.id || search) {
        const res = await HelperServices.getAllValidAreas({
          city: cityId,
          smart_search: search,
        });
        setAreas(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const dbounceBuilding = useCallback(
    debounce(1000, (searchBuilValue: string, cityId: any, areaId?: any) => {
      searchBuilding(searchBuilValue, +cityId, +areaId);
    }),
    []
  );

  const handleBuilingSearch = (value: string, cityId: any, areaId?: any) => {
    dbounceBuilding(value, cityId, areaId);
  };

  async function searchBuilding(
    search: string,
    cityId: number,
    selectedAreaId?: any
  ) {
    try {
      if (decryptedParams.id || search.length > 2) {
        const res = await HelperServices.getAllValidBuildings({
          area: +selectedAreaId,
          city: +cityId,
          smart_search: search,
        });
        setBuildings(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    // hide area result on out side click
    //review comment: can we use onBlur on area field rather than adding a event listener on the whole window ? This is an anti pattern in react
    function handleClickOutside(event: any) {
      if (areaRef.current && !areaRef.current.contains(event.target)) {
        setAreas([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [areaRef]);

  useEffect(() => {
    // hide building result on out side click
    //review comment: can we use onBlur on area field rather than adding a event listener on the whole window ? This is an anti pattern in react TP
    function handleClickOutsidebuilding(event: any) {
      if (buildingRef.current && !buildingRef.current.contains(event.target)) {
        setBuildings([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutsidebuilding);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsidebuilding);
    };
  }, [buildingRef]);

  const onSubmit = (val: any) => {
    const form = new FormData();
    for (var key in formData) {
      if (isNotNull(val[key])) form.append(key, val[key]);
    }
    if (!decryptedParams.id) {
      if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
        form.set("comp_id", UtilityServices.getLoggedInUser("company_id"));
      } else if (
        UtilityServices.getLoggedInUser("user_type") === roleTypeArr.backend &&
        !company.id
      ) {
        UtilityServices.showToaster({
          type: "warning",
          message: t("PLEASE_SELECT_FIELD", {
            field: t("COMPANY").toLowerCase(),
          }),
        });
        return;
      } else if (company.id) {
        form.set("comp_id", company.id);
      }
    }

    if (decryptedParams.id) {
      form.delete("comp_id");
      saveStore(form, decryptedParams.id);
    } else {
      saveStore(form);
    }
  };

  const handleSetPrimaryUser = () => {
    setOpenModalByName("set-primary-user");
  };
  const handleImportProducts = () => {
    navigate(
      ContentRoutes.IMPORT_PRODUCTS_FOR_STORE.replace(
        ":id",
        ecryptedStoreId.toString()
      )
    );
  };

  return (
    <div className="store">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Container className="container">
        <Header className="header">
          <h4 className="mb-2">
            {decryptedParams.id ? t("UPDATE") : t("CREATE")} {t("STORE")}
          </h4>
        </Header>
        <Content className="content store-create-wrap">
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {};
              if (!values.store_name) {
                errors.store_name = t("REQUIRED", {
                  field:
                    t("STORE").toLowerCase() + " " + t("NAME").toLowerCase(),
                });
              }
              if (!values.store_code) {
                errors.store_code = t("REQUIRED", {
                  field:
                    t("STORE").toLowerCase() + " " + t("CODE").toLowerCase(),
                });
              }
              if (!values.mobile) {
                errors.mobile = t("REQUIRED", {
                  field: t("MOBILE").toLowerCase(),
                });
              }
              if (
                values.mobile &&
                values.mobile.length !== appConstObj.mobile_length
              ) {
                errors.mobile = t("VALID", {
                  entity: t("MOBILE").toLowerCase(),
                });
              }
              if (!values.country_id) {
                errors.country_id = t("REQUIRED", {
                  field: t("COUNTRY").toLowerCase(),
                });
              }
              if (!values.state_id) {
                errors.state_id = t("REQUIRED", {
                  field: t("STATE").toLowerCase(),
                });
              }
              if (!values.city_id) {
                errors.city_id = t("REQUIRED", {
                  field: t("CITY").toLowerCase(),
                });
              }
              if (!values.area_name) {
                errors.area_name = t("REQUIRED", {
                  field: t("AREA").toLowerCase(),
                });
              }
              if (!values.house_no) {
                errors.house_no = t("REQUIRED", {
                  field: t("HOUSE_NO").toLowerCase(),
                });
              }
              if (!values.pincode) {
                errors.pincode = t("REQUIRED", {
                  field: t("PINCODE").toLowerCase(),
                });
              }
              return errors;
            }}
            initialValues={{ ...formData }}
            render={({ handleSubmit, form }) => (
              <form onSubmit={handleSubmit}>
                <div className="form-part">
                  <div className="flex-container">
                    <Field
                      name="store_name"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("STORE")} {t("NAME")}*
                          </label>
                          <input {...input} type="text" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="store_code"
                      validate={
                        ValidatorCustom.isAlphaNumericWithDashPatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("STORE")} {t("CODE")}*
                          </label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="mobile"
                      validate={ValidatorCustom.mobilePatternValidation}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("MOBILE")}*</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>

                  <div className="flex-container">
                    <Field
                      name="contact_person1_name"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("CONTACT_PERSON1")} {t("NAME")}
                          </label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="contact_person1_phone"
                      validate={ValidatorCustom.mobilePatternValidation}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("CONTACT_PERSON1")} {t("PHONE")}
                          </label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="contact_person1_email"
                      validate={ValidatorCustom.emailPatternValidator}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("CONTACT_PERSON1")} {t("EMAIL")}
                          </label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field
                      name="contact_person2_name"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("CONTACT_PERSON2")} {t("NAME")}
                          </label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="contact_person2_phone"
                      validate={ValidatorCustom.mobilePatternValidation}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("CONTACT_PERSON2")} {t("PHONE")}
                          </label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="contact_person2_email"
                      validate={ValidatorCustom.emailPatternValidator}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("CONTACT_PERSON2")} {t("EMAIL")}
                          </label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  {UtilityServices.hasLoggedInUserType(roleTypeArr.backend) && (
                    <div className="flex-container">
                      <Field name="region_id">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={false}
                              valueKey="id"
                              labelKey="region_name"
                              labelName={t("REGION")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("region_id", "");
                                form.change("store_group_id", "");
                                setStoreGroupList([]);
                              }}
                              listData={regionList}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("region_id", e);
                                handleRegionChange(e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="store_group_id">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              valueKey="id"
                              labelKey="group_name"
                              isRequired={false}
                              labelName={t("GROUP")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("store_group_id", "");
                              }}
                              listData={storeGroupList}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("store_group_id", e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="status">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label className="block">{t("STATUS")}*</label>
                            <Radio
                              onChangeCapture={(e: any) => {
                                if (e.target.checked) {
                                  form.change("status", 1);
                                }
                              }}
                              checked={input.value === 1 ? true : false}
                              name="status"
                              value="1"
                            >
                              {t("ACTIVE")}
                            </Radio>
                            <Radio
                              onChangeCapture={(e: any) => {
                                if (e.target.checked) {
                                  form.change("status", 0);
                                }
                              }}
                              checked={input.value === 0 ? true : false}
                              name="status"
                              value="0"
                            >
                              {t("INACTIVE")}
                            </Radio>
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                  )}
                </div>
                <div className="address-bx">
                  <h5>{t("ADDRESS")}</h5>
                </div>
                <div className="form-part">
                  <div className="flex-container">
                    <Field name="country_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field: t("COUNTRY").toLocaleLowerCase(),
                            })}
                            isRequired={true}
                            valueKey="id"
                            labelKey="country_name"
                            isDisable={!countryList?.length ? true : false}
                            labelName={t("COUNTRY")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("country_id", "");
                              form.change("state_id", "");
                              form.change("city_id", "");
                              form.change("building", "");
                              form.change("area_name", "");
                              setStateList([]);
                              setCityList([]);
                            }}
                            listData={countryList?.length ? countryList : []}
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("country_id", e);
                              handleCountryChange(e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="state_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={
                              form.getState().values.country_id &&
                              !stateList?.length
                                ? t("FETCHING_DATA_OF", {
                                    field: t("STATE").toLocaleLowerCase(),
                                  })
                                : ""
                            }
                            valueKey="id"
                            labelKey="state_name"
                            isRequired={true}
                            isDisable={!stateList?.length ? true : false}
                            labelName={t("STATE")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("state_id", "");
                              form.change("city_id", "");
                              form.change("building", "");
                              form.change("area_name", "");
                              setCityList([]);
                            }}
                            listData={
                              form.getState().values.country_id &&
                              stateList?.length
                                ? stateList
                                : [{}]
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("state_id", e);
                              handleStateChange(e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                          {meta.error &&
                            meta.touched &&
                            form.getState().values.country_id &&
                            !stateList?.length && <br />}
                          {form.getState().values.country_id &&
                            !stateList?.length &&
                            !stateFetched && (
                              <span>
                                {t("FETCHING_DATA_OF", { field: t("STATE") })}
                              </span>
                            )}
                          {form.getState().values.country_id &&
                            !stateList?.length &&
                            stateFetched && (
                              <span>
                                {t("NO_DATA_FOUND_OF", {
                                  field: t("STATE").toLocaleLowerCase(),
                                })}
                              </span>
                            )}
                        </div>
                      )}
                    </Field>
                    <Field name="city_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={
                              form.getState().values.state_id &&
                              !cityList?.length
                                ? t("FETCHING_DATA_OF", { field: t("CITY") })
                                : ""
                            }
                            valueKey="id"
                            labelKey="city_name"
                            isRequired={true}
                            isDisable={!cityList?.length ? true : false}
                            labelName={t("CITY")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("city_id", "");
                              form.change("building", "");
                              form.change("area_name", "");
                            }}
                            listData={
                              form.getState().values.state_id &&
                              cityList?.length
                                ? cityList
                                : [{}]
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("city_id", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                          {meta.error &&
                            meta.touched &&
                            form.getState().values.state_id &&
                            !cityList?.length && <br />}
                          {form.getState().values.state_id &&
                            !cityList?.length &&
                            !cityFetched && (
                              <span>
                                {t("FETCHING_DATA_OF", {
                                  field: t("CITY").toLocaleLowerCase(),
                                })}
                              </span>
                            )}
                          {form.getState().values.state_id && cityFetched && (
                            <span>
                              {t("NO_DATA_FOUND_OF", {
                                field: t("CITY").toLocaleLowerCase(),
                              })}
                            </span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field name="house_no">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("HOUSE_NO")}*</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="area_name">
                      {({ input, meta }) => (
                        <div className="flex-item" ref={areaRef}>
                          <label>{t("AREA")}*</label>
                          <input
                            {...input}
                            type="text"
                            disabled={
                              form.getState().values.city_id ? false : true
                            }
                            autoComplete="off"
                            onChange={(event: any) => {
                              handleAreaSearch(
                                event.target.value,
                                form.getState().values.city_id
                              );
                              form.change("area_name", event.target.value);
                            }}
                          />
                          {meta.modified && areas && areas.length ? (
                            <div className="tarea-nm-bx">
                              {areas &&
                                areas.length &&
                                areas.map((area: any, index) => {
                                  return (
                                    <div key={index}>
                                      <label
                                        className="tarea-nm-lbl"
                                        onClick={(e: any) => {
                                          form.change(
                                            "area_name",
                                            area.area_name
                                          );
                                          setSelectedAreaId(area.id);
                                          setAreas([]);
                                        }}
                                      >
                                        {area && area.area_name}
                                      </label>{" "}
                                      <br />
                                    </div>
                                  );
                                })}
                            </div>
                          ) : null}
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="building">
                      {({ input, meta }) => (
                        <div className="flex-item" ref={buildingRef}>
                          <label>{t("BUILDING")}</label>
                          <input
                            {...input}
                            type="text"
                            disabled={
                              form.getState().values.city_id ? false : true
                            }
                            autoComplete="off"
                            onChange={(event: any) => {
                              handleBuilingSearch(
                                event.target.value,
                                form.getState().values.city_id,
                                selectedAreaId
                              );
                              form.change("building", event.target.value);
                            }}
                          />
                          {meta.modified && buildings?.length ? (
                            <div className="tarea-nm-bx">
                              {meta.touched &&
                                buildings?.length &&
                                buildings.map((building: any, index) => {
                                  return (
                                    <div key={index}>
                                      <label
                                        className="tarea-nm-lbl"
                                        onClick={(e: any) => {
                                          form.change(
                                            "building",
                                            building.building_name
                                          );
                                          setBuildings([]);
                                        }}
                                      >
                                        {building && building.building_name}
                                      </label>{" "}
                                      <br />
                                    </div>
                                  );
                                })}
                            </div>
                          ) : null}
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field name="landmark">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("LANDMARK")}</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="pincode"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("PINCODE")}*</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="landline">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("LANDLINE")}</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                </div>
                <div className="create-action d-flex flex-end">
                  <Link to={ContentRoutes.STORES}>
                    <Button appearance="primary" color="blue" type="button">
                      {t("BACK")} {t("TO").toLocaleLowerCase()}{" "}
                      {t("LIST").toLocaleLowerCase()}
                    </Button>
                  </Link>
                  <Button appearance="primary" color="green" type="submit">
                    {decryptedParams.id ? t("UPDATE") : t("CREATE")}
                  </Button>
                  {decryptedParams.id && (
                    <>
                      {UtilityServices.hasPermission("create-user") && (
                        <Button
                          appearance="primary"
                          color="blue"
                          onClick={handleSetPrimaryUser}
                        >
                          {storeData?.primary_user_id
                            ? t("UPDATE") +
                              " " +
                              t("PRIMARY") +
                              " " +
                              t("MANAGER")
                            : t("CREATE") +
                              " " +
                              t("PRIMARY") +
                              " " +
                              t("MANAGER")}
                        </Button>
                      )}

                      {UtilityServices.hasPermission(
                        "import-product-for-store"
                      ) && (
                        <Button
                          appearance="primary"
                          color="blue"
                          onClick={handleImportProducts}
                        >
                          {t("IMPORT") + " " + t("PRODUCTS")}
                        </Button>
                      )}
                    </>
                  )}
                  <Button
                    appearance="default"
                    type="reset"
                    onClick={() => {
                      // review comment: move to new function
                      form.reset();
                      if (form.getState().values.country_id) {
                        handleCountryChange(form.getState().values.country_id);
                      }
                      if (form.getState().values.state_id) {
                        handleStateChange(form.getState().values.state_id);
                      }
                    }}
                  >
                    {t("RESET")}
                  </Button>
                </div>
              </form>
            )}
          />
          {openModalByName === "set-primary-user" && decryptedParams.id && (
            <UserForStore
              storeId={decryptedParams.id}
              openModal={true}
              setOpenModal={setOpenModalByName}
              onComplete={onCompletePrimaryUser}
            />
          )}
        </Content>
      </Container>
    </div>
  );
}

export default Store;
